import React from 'react';
import CloseButton from './CloseButton';
import WordMatching from './WordMatching';
import MemoryGame from './MemoryGame';
import PicturePuzzle from './PicturePuzzle';
import SoundMatching from './SoundMatching';
import QuickQuiz from './QuickQuiz';
import AlphabetOrdering from './AlphabetOrdering';

const components = {
    WordMatching: WordMatching,
    MemoryGame: MemoryGame,
    PicturePuzzle: PicturePuzzle,
    SoundMatching: SoundMatching,
    QuickQuiz: QuickQuiz,
    AlphabetOrdering: AlphabetOrdering
};

function GamePopup({ selectedGame, onClose }) {
    // Get the correct component based on the selected game title
    const GameComponent = components[selectedGame];

    if (!GameComponent) return null;

    return (
        <div className="game-popup" onClick={onClose}>
            <div className="game-popup-content" onClick={(e) => e.stopPropagation()}>
                <CloseButton onClick={onClose} variant="game-popup" label="X" />
                <GameComponent onClose={onClose} />
            </div>
        </div>
    );
}

export default GamePopup;
